export default __webpack_public_path__ + "static/hero-bg-min-ca809373017bef2b8a1065c29d4a142d.webp";